export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  contentHtml: string;
  category: string;
  imageUrl: string;
  date: string;
  readTime: string;
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageUrl: string;
}

export interface Review {
  name: string;
  role: string;
  content: string;
  rating: number;
}

export interface FAQ {
  question: string;
  answer: string;
}

export const categories: Category[] = [
  {
    slug: 'shengzhang-xixing',
    name: '生长习性',
    description: '了解害羞草的天然生长环境、形态特征与生命周期',
    icon: 'ri-leaf-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20close-up%20macro%20photograph%20of%20a%20Mimosa%20pudica%20sensitive%20plant%20with%20its%20delicate%20feathery%20green%20leaves%20fully%20open%20growing%20naturally%20in%20tropical%20soil%20soft%20morning%20sunlight%20filtering%20through%20leaves%20botanical%20photography%20style%20with%20shallow%20depth%20of%20field%20natural%20earth%20tones%20and%20vibrant%20green%20hues%20clean%20simple%20background%20of%20blurred%20forest%20floor&width=800&height=600&seq=cat-growth-habits&orientation=landscape',
  },
  {
    slug: 'zhongzhi-fangfa',
    name: '种植方法',
    description: '从选种到育苗，手把手教你种出健康的害羞草',
    icon: 'ri-seedling-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20small%20terracotta%20pot%20with%20young%20Mimosa%20pudica%20seedlings%20sprouting%20from%20rich%20dark%20soil%20on%20a%20sunny%20windowsill%20gardening%20tools%20scattered%20nearby%20including%20a%20small%20trowel%20and%20watering%20can%20bright%20natural%20morning%20light%20streaming%20through%20window%20cozy%20home%20gardening%20atmosphere%20warm%20and%20inviting%20composition%20clean%20cream%20wall%20background&width=800&height=600&seq=cat-planting-methods&orientation=landscape',
  },
  {
    slug: 'yanghu-jiqiao',
    name: '养护技巧',
    description: '浇水、施肥、修剪——日常养护的完整指南',
    icon: 'ri-plant-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20healthy%20mature%20Mimosa%20pudica%20plant%20in%20a%20decorative%20ceramic%20pot%20on%20a%20wooden%20table%20someone%20gently%20misting%20water%20droplets%20on%20the%20leaves%20with%20a%20spray%20bottle%20soft%20diffused%20indoor%20lighting%20cozy%20home%20interior%20with%20neutral%20tones%20plant%20care%20lifestyle%20photography%20warm%20and%20nurturing%20atmosphere%20simple%20elegant%20composition&width=800&height=600&seq=cat-care-tips&orientation=landscape',
  },
  {
    slug: 'kexue-yuanli',
    name: '科学原理',
    description: '揭秘叶片闭合背后的植物生理学机制',
    icon: 'ri-microscope-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Scientific%20illustration%20style%20artwork%20showing%20the%20cellular%20mechanism%20of%20Mimosa%20pudica%20leaf%20movement%20cross-section%20diagram%20of%20pulvinus%20motor%20cells%20with%20water%20flow%20arrows%20educational%20botanical%20artwork%20clean%20white%20background%20with%20subtle%20grid%20pattern%20detailed%20anatomical%20style%20with%20Latin%20labels%20professional%20scientific%20visualization&width=800&height=600&seq=cat-science-principles&orientation=landscape',
  },
  {
    slug: 'changjian-wenti',
    name: '常见问题',
    description: '黄叶、不闭合、病虫害……常见问题一网打尽',
    icon: 'ri-question-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20Mimosa%20pudica%20plant%20showing%20both%20healthy%20green%20leaves%20and%20some%20yellowing%20leaves%20side%20by%20side%20for%20comparison%20placed%20on%20a%20bright%20windowsill%20educational%20comparison%20style%20photography%20clean%20background%20with%20soft%20natural%20light%20botanical%20documentation%20style%20clear%20visual%20contrast%20between%20healthy%20and%20stressed%20plant%20conditions&width=800&height=600&seq=cat-faq-problems&orientation=landscape',
  },
];

export const articles: Article[] = [
  {
    slug: 'hanxiucao-de-qiyuan-yu-fenbu',
    title: '害羞草的起源与自然分布',
    excerpt: '害羞草原产于热带美洲，从巴西到墨西哥的广大区域都有其野生踪迹。如今它已遍布全球热带和亚热带地区，成为一种广受欢迎的观赏植物。',
    contentHtml: `<p>害羞草（学名：<em>Mimosa pudica</em> L.），又称含羞草、知羞草、怕羞草，是豆科含羞草属的多年生草本植物。它原产于中美洲和南美洲的热带地区，尤其以巴西、委内瑞拉和哥伦比亚等地最为常见。</p>
    <p>在野外环境中，害羞草通常生长在开阔的草地、路边、河岸以及森林边缘，喜欢温暖湿润的气候条件。由于它独特的叶片感应运动，早在18世纪就被欧洲植物学家引入温室栽培，随后逐渐传播到世界各地的热带和亚热带区域。</p>
    <p>如今，害羞草在东南亚、南亚、非洲和太平洋岛屿等地已经归化，成为当地生态系统的一部分。在中国，害羞草主要分布在广东、广西、云南、福建、海南、台湾等南方省份，常被作为盆栽观赏植物或庭院绿化植物栽种。</p>
    <p>害羞草属于匍匐性草本，茎多分枝，全株散生锐刺和倒刺毛。植株通常能长到30到60厘米高，在适宜的条件下甚至可以超过1米。它的花是淡粉红色或紫红色的球形头状花序，盛开时如同一颗颗柔软的小绒球，十分可爱。</p>
    <p>在它的原产地，害羞草被视为一种普通的野生植物，有时甚至被当作杂草。但在世界各地，人们被它那神奇的"害羞"特性所吸引，把它当作一种富有灵性的观赏植物来精心培育。了解它的起源，有助于我们为它创造最接近原生环境的生长条件。</p>`,
    category: 'shengzhang-xixing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20Mimosa%20pudica%20plant%20growing%20naturally%20in%20a%20tropical%20Brazilian%20grassland%20landscape%20warm%20golden%20hour%20sunlight%20lush%20green%20vegetation%20surrounding%20the%20delicate%20plant%20distant%20mountains%20blurred%20in%20background%20natural%20wild%20habitat%20scene%20documentary%20nature%20photography%20style%20earthy%20warm%20tones%20throughout%20peaceful%20untouched%20wilderness%20atmosphere&width=640&height=360&seq=article-origin&orientation=landscape',
    date: '2026-07-15',
    readTime: '5 分钟',
  },
  {
    slug: 'yepian-yundong-de-aomi',
    title: '叶片运动的奥秘：触碰即合的机制',
    excerpt: '害羞草为什么一碰就"害羞"？这背后是一套精妙的细胞液压系统。当叶片受到刺激时，叶枕处的细胞迅速失水，导致叶片下垂闭合。',
    contentHtml: `<p>害羞草最令人着迷的特性，莫过于它那一碰就合的叶片运动。这种被称为"感震性"的运动，是植物界最快速的反应之一——从触碰发生到叶片开始闭合，只需0.1秒左右。</p>
    <p>科学上，这种运动的机制与叶片基部一个叫做"叶枕"的特殊结构密切相关。叶枕由一群膨大的薄壁细胞组成，这些细胞内充满了水分。当叶片受到机械刺激（如触碰、风吹、雨滴等）时，刺激信号会迅速传递到叶枕部位。</p>
    <p>信号的传递涉及复杂的电生理过程和化学信号分子。研究发现，动作电位沿茎部传导，同时伴随钙离子、钾离子和氯离子在细胞膜两侧的快速流动。这些离子的重新分布改变了细胞内的渗透压，导致叶枕下侧的细胞迅速失去水分、体积缩小，而上侧细胞保持膨胀——这种不对称的膨压变化最终导致了叶片的弯曲下垂。</p>
    <p>特别有趣的是，刺激信号不仅可以传递到被触碰的那片叶子，还能传导给同一植株上的其他叶片。如果你持续触碰一株害羞草，整株植物的叶片都会依次闭合，呈现出一种"波浪式"的传播效果。</p>
    <p>进化生物学家认为，这种快速闭合运动是一种防御机制。当昆虫落在叶片上时，叶片的突然下垂可能惊吓或抖落食草昆虫，同时闭合的叶片也改变了植物的外观，可能让食草动物误以为这是一株枯萎或不新鲜的植物而放弃取食。</p>
    <p>大约5到10分钟后，如果不再受到新的刺激，叶片会慢慢恢复到原来的展开状态。但如果反复刺激同一植株，它会逐渐"习惯"而不再闭合——这说明害羞草具有某种形式的"学习"或"记忆"能力，是植物智能研究的热门课题。</p>`,
    category: 'kexue-yuanli',
    imageUrl: 'https://readdy.ai/api/search-image?query=Close-up%20scientific%20illustration%20showing%20a%20Mimosa%20pudica%20leaf%20in%20both%20open%20and%20closed%20states%20detailed%20diagram%20of%20pulvinus%20cellular%20structure%20with%20water%20movement%20arrows%20educational%20botanical%20artwork%20on%20clean%20white%20background%20anatomical%20cross-section%20style%20professional%20scientific%20visualization%20with%20labeled%20parts%20in%20Latin%20botanical%20terms%20precise%20and%20accurate%20representation&width=640&height=360&seq=article-movement&orientation=landscape',
    date: '2026-07-18',
    readTime: '8 分钟',
  },
  {
    slug: 'ruhe-cong-zhongzi-kaishi-zhongzhi',
    title: '如何从种子开始种植害羞草',
    excerpt: '从一粒小小的种子到一株会"害羞"的可爱植物，整个过程充满乐趣。本文将详细介绍选种、催芽、播种到幼苗管理的每一步操作。',
    contentHtml: `<p>从种子开始种植害羞草，是体验植物生命奇迹的绝佳方式。害羞草的种子表面有一层坚硬的种皮，直接播种发芽率较低，因此需要先进行预处理。</p>
    <h4>第一步：种子预处理</h4>
    <p>将种子放入50-60度的温水中浸泡12-24小时。热量能够软化种皮，促进水分吸收。浮在水面的种子通常是空瘪的，可以直接丢弃。沉在水底的种子才是饱满有活力的好种子。</p>
    <p>另一种更高效的方法是用细砂纸轻轻打磨种子表面，磨薄种皮但不伤及胚芽。磨好后再用温水浸泡6-8小时，发芽率可以提高到90%以上。</p>
    <h4>第二步：准备土壤</h4>
    <p>害羞草喜欢疏松、排水良好的土壤。推荐配方：腐叶土：园土：河沙 = 3：2：1。确保花盆底部有排水孔，并在盆底垫一层碎瓦片或陶粒以增强排水性。土壤pH值以6.0-7.0的微酸性到中性为宜。</p>
    <h4>第三步：播种</h4>
    <p>将处理好的种子均匀撒在土壤表面，然后覆盖一层约0.5厘米厚的薄土。用喷壶轻轻喷湿土壤，不要大水浇灌以免冲走种子。播种的最佳温度是20-28度，春秋两季最为适宜。</p>
    <h4>第四步：育苗管理</h4>
    <p>将花盆放在温暖明亮但避免阳光直射的地方。保持土壤始终微湿但不积水。在适宜条件下，种子通常7-14天后就会发芽。当幼苗长出2-3片真叶时，就可以移植到稍大的花盆中了。</p>
    <p>小苗时期的害羞草非常娇嫩，要避免强光暴晒和过度浇水。用细嘴喷壶轻轻浇水，保持土壤湿润即可。</p>`,
    category: 'zhongzhi-fangfa',
    imageUrl: 'https://readdy.ai/api/search-image?query=Top-down%20flat%20lay%20photography%20of%20Mimosa%20pudica%20seeds%20on%20dark%20rich%20potting%20soil%20in%20a%20small%20terracotta%20pot%20gardening%20tools%20including%20a%20small%20trowel%20and%20spray%20bottle%20arranged%20neatly%20around%20the%20pot%20on%20a%20rustic%20wooden%20surface%20bright%20natural%20window%20light%20home%20gardening%20aesthetic%20warm%20and%20inviting%20composition%20shallow%20depth%20of%20field%20focused%20on%20the%20seeds&width=640&height=360&seq=article-seed&orientation=landscape',
    date: '2026-07-20',
    readTime: '7 分钟',
  },
  {
    slug: 'qiancha-fanzhi-jishu',
    title: '扦插繁殖技术：快速获得新植株',
    excerpt: '除了播种，害羞草也可以通过扦插繁殖。选择健康的枝条，掌握正确的扦插方法，几周后就能收获一株新的害羞草。',
    contentHtml: `<p>扦插繁殖是害羞草快速繁衍的一种有效方法，尤其适合想要保留母株优良性状的情况。相比种子繁殖，扦插苗生长更快，成活率也很高。</p>
    <h4>选择插穗</h4>
    <p>选择生长健壮、无病虫害的半木质化枝条作为插穗。每条插穗长度以8-12厘米为宜，保留2-3个节位。剪口要平滑，上端在节的上方约0.5厘米处平剪，下端在节的下方约1厘米处斜剪（45度角），以增大吸水面积。</p>
    <h4>扦插基质</h4>
    <p>使用洁净的河沙、蛭石或珍珠岩作为扦插基质。这些材料透气性好、排水快，能有效防止插穗腐烂。扦插前将基质浇透水，稍等片刻让多余水分排出。</p>
    <h4>扦插步骤</h4>
    <p>将处理好的插穗下端约三分之一插入基质中，轻轻压实周围的基质。扦插后浇一次透水，然后放在半阴通风处养护。可以用透明的塑料袋或塑料瓶罩住扦插盆，以保持高湿度环境。</p>
    <h4>后期管理</h4>
    <p>维持20-25度的温度和70%-80%的空气湿度。每天揭开罩子通风15-20分钟，防止霉菌滋生。大约2-3周后，插穗开始生根。生根的标志是顶端开始长出新的嫩叶，这时可以逐渐增加光照，并移去保湿罩。</p>`,
    category: 'zhongzhi-fangfa',
    imageUrl: 'https://readdy.ai/api/search-image?query=Close-up%20of%20a%20hand%20carefully%20inserting%20a%20fresh%20Mimosa%20pudica%20stem%20cutting%20into%20a%20small%20pot%20filled%20with%20vermiculite%20propagation%20medium%20gardening%20gloves%20nearby%20bright%20natural%20window%20light%20indoor%20propagation%20station%20setup%20with%20small%20pots%20lined%20up%20soft%20focus%20background%20showing%20a%20mist%20spray%20bottle%20educational%20propagation%20guide%20photography%20warm%20and%20clean%20aesthetic&width=640&height=360&seq=article-cutting&orientation=landscape',
    date: '2026-07-22',
    readTime: '6 分钟',
  },
  {
    slug: 'turang-yu-feiliao-xuanze',
    title: '土壤与肥料选择指南',
    excerpt: '好的土壤是害羞草健康生长的基础。从土壤配比到施肥方案，这份指南将帮助你为害羞草打造最理想的生长环境。',
    contentHtml: `<p>土壤是害羞草赖以生存的根基，选择合适的土壤和科学的施肥方案，是养好害羞草的关键一步。</p>
    <h4>理想土壤特性</h4>
    <p>害羞草的根系对积水非常敏感，因此排水性是最重要的土壤指标。理想的土壤应同时具备良好的排水性和适度的保水能力。疏松、透气、富含有机质的微酸性到中性土壤最为合适。</p>
    <p>推荐土壤配方：腐叶土或泥炭土（40%）、园土（30%）、河沙或珍珠岩（30%）。此配方能够提供充足的养分，同时确保根系的良好呼吸。</p>
    <h4>施肥原则</h4>
    <p>害羞草不是重肥植物，施肥应遵循"薄肥勤施"的原则。在生长旺季（春末至秋初），每隔15-20天施一次稀释的液体肥。冬季休眠期则完全停止施肥。</p>
    <p>氮肥促进叶片生长，磷肥促进根系发育和开花，钾肥增强植株抗性。推荐使用氮磷钾均衡的复合肥（如20-20-20），稀释到推荐浓度的一半使用。有机肥如腐熟的饼肥水也是不错的选择，但一定要充分腐熟稀释，以免烧根。</p>
    <h4>换盆与土壤更新</h4>
    <p>害羞草生长较快，建议每年春季换盆一次。换盆时更换三分之一到一半的旧土，加入新的培养土，同时适当修剪老根和过长的根系。</p>`,
    category: 'yanghu-jiqiao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Flat%20lay%20arrangement%20of%20gardening%20soil%20mix%20ingredients%20on%20a%20wooden%20table%20including%20dark%20compost%20perlite%20peat%20moss%20and%20small%20clay%20pebbles%20in%20separate%20bowls%20a%20small%20Mimosa%20pudica%20plant%20in%20a%20terracotta%20pot%20at%20the%20center%20gardening%20gloves%20and%20a%20hand%20trowel%20neatly%20placed%20bright%20natural%20overhead%20light%20organized%20and%20educational%20composition%20warm%20earthy%20color%20palette&width=640&height=360&seq=article-soil&orientation=landscape',
    date: '2026-07-25',
    readTime: '6 分钟',
  },
  {
    slug: 'jiaoshui-yu-guangzhao-guanli',
    title: '浇水与光照管理全攻略',
    excerpt: '水多烂根、水少枯萎，光照强弱直接影响叶片感应灵敏度。掌握浇水和光照的平衡艺术，让你的害羞草始终保持最佳状态。',
    contentHtml: `<p>浇水和光照是害羞草日常养护中最核心的两大要素。很多养护失败的原因，都可以归结为这两方面出了问题。</p>
    <h4>浇水黄金法则</h4>
    <p>害羞草喜欢湿润但不耐积水。浇水的黄金法则是：见干见湿。即等到盆土表面以下约2厘米处变干时再浇水，每次浇到水从盆底排水孔流出为止。</p>
    <p>春夏季生长旺盛期，通常每2-3天浇水一次，具体频率取决于环境温度和花盆大小。夏季高温干燥时可能需要每天浇水。秋冬季则减少到每周一次左右。判断是否需要浇水的最可靠方法是用手指插入土壤感受湿度，而不是机械地按天数计算。</p>
    <p>浇水时间也很重要。夏季最好在清晨或傍晚浇水，避免中午高温时浇水导致根系"烫伤"。冬季则在温暖的中午时段浇水，使用与室温相近的水温。</p>
    <h4>光照需求</h4>
    <p>害羞草是喜光植物，需要充足的散射光才能健康生长。最佳位置是朝南或朝东的窗台，每天接受4-6小时的明亮散射光。充足的光照还能让叶片的"害羞"反应更加灵敏。</p>
    <p>但要注意，夏季正午的强烈直射光会灼伤叶片，导致叶缘发黄焦枯。如果放在室外，需要选择半阴位置或使用遮阳网。冬季日照时间短，可以适当补充人工光源。</p>
    <p>光照不足的明显信号：植株徒长（茎细长、节间拉长）、叶片颜色变淡、开花减少或不开花、叶片感应变迟钝。</p>`,
    category: 'yanghu-jiqiao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20healthy%20Mimosa%20pudica%20plant%20on%20a%20bright%20sunny%20windowsill%20someone%20using%20a%20small%20copper%20watering%20can%20to%20gently%20water%20the%20soil%20soft%20morning%20sunlight%20streaming%20through%20the%20window%20creating%20warm%20highlights%20indoor%20plant%20care%20scene%20lifestyle%20photography%20warm%20and%20natural%20atmosphere%20cream-colored%20walls%20and%20wooden%20windowsill%20calm%20and%20nurturing%20composition&width=640&height=360&seq=article-water-light&orientation=landscape',
    date: '2026-07-28',
    readTime: '7 分钟',
  },
  {
    slug: 'bingchonghai-fangzhi-shouce',
    title: '病虫害防治完全手册',
    excerpt: '害羞草虽然整体抗性较强，但在养护不当的情况下仍可能遭遇蚜虫、红蜘蛛、白粉病等困扰。及早发现、正确处理是关键。',
    contentHtml: `<p>害羞草虽然相对皮实，但在高温高湿、通风不良或养护不当的情况下，仍可能受到病虫害的侵袭。以下是常见病虫害的识别与防治方法。</p>
    <h4>蚜虫</h4>
    <p>蚜虫是最常见的害羞草害虫，通常聚集在嫩叶和嫩芽上吸食汁液。受害叶片会卷曲变形，严重时植株生长停滞。发现蚜虫后，先用清水冲洗，然后用稀释的肥皂水（1：500）喷洒，每周一次，连续2-3次。也可以使用印楝油或吡虫啉等低毒杀虫剂。</p>
    <h4>红蜘蛛</h4>
    <p>红蜘蛛在干燥炎热的环境中特别容易爆发。它们在叶片背面吸食汁液，导致叶片出现黄白色斑点，严重时叶片枯黄脱落。防治方法是增加空气湿度，经常向叶片喷水。可以使用阿维菌素或联苯肼酯等专用杀螨剂，注意叶片正反面都要喷到。</p>
    <h4>白粉病</h4>
    <p>白粉病表现为叶片表面出现白色粉末状物质，多发生在通风不良、湿度过高的环境中。预防措施是保持良好的通风，避免过度密集种植。发病后可以使用硫磺制剂或三唑酮等杀菌剂进行治疗。</p>
    <h4>根腐病</h4>
    <p>根腐病是浇水过多导致的最严重问题。植株表现为叶片萎蔫、茎基部变黑腐烂。预防胜过治疗——确保土壤排水良好、避免积水。一旦发生严重根腐，通常难以挽救。轻度根腐可以尝试剪除腐烂根系、更换干燥新土、减少浇水。</p>`,
    category: 'yanghu-jiqiao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Educational%20comparison%20photograph%20showing%20a%20healthy%20Mimosa%20pudica%20leaf%20on%20the%20left%20and%20a%20leaf%20affected%20by%20aphids%20on%20the%20right%20white%20background%20clear%20labeling%20and%20visual%20contrast%20botanical%20documentation%20style%20scientific%20but%20accessible%20presentation%20soft%20diffused%20studio%20lighting%20detailed%20macro%20view%20showing%20the%20tiny%20insects%20on%20the%20affected%20leaf&width=640&height=360&seq=article-pest&orientation=landscape',
    date: '2026-08-01',
    readTime: '8 分钟',
  },
  {
    slug: 'zhiwu-shenjing-xitong-tanmi',
    title: '植物"神经系统"探秘',
    excerpt: '害羞草拥有类似动物神经系统的信号传导机制。电信号在植株体内以每秒数厘米的速度传播，这在植物界极为罕见。',
    contentHtml: `<p>害羞草的快速反应能力引发了科学界长期的兴趣。植物没有真正意义上的神经细胞，但害羞草却能够以惊人的速度传导刺激信号——其中的奥秘是什么？</p>
    <h4>动作电位的发现</h4>
    <p>早在19世纪末，科学家就首次在害羞草中记录到了动作电位——一种类似于动物神经细胞中传播的电信号。当害羞草的叶片受到触碰时，刺激点会产生一个约50-100毫伏的去极化电位变化，这个电信号沿着维管束以每秒2-5厘米的速度向远处传播。</p>
    <h4>韧皮部的角色</h4>
    <p>研究表明，害羞草的电信号主要在韧皮部的筛管分子中传导。筛管分子是连接在一起的长管状细胞，负责运输光合产物。它们在结构上与动物的神经轴突有某些相似之处，特别是都具备细长的管状形态和细胞间的连接通道。</p>
    <h4>化学信号的协同</h4>
    <p>电信号只是故事的一部分。在电信号传播的同时，害羞草还会释放化学信号分子。近年来的研究发现，谷氨酸受体类似物在信号传导中扮演重要角色——这很有意思，因为谷氨酸正是动物神经系统中最重要的兴奋性神经递质。</p>
    <h4>植物智能的启示</h4>
    <p>害羞草的这些特性挑战了我们对植物"感知能力"的传统认知。虽然植物的电信号系统远比动物的神经系统简单，但它们确实能够感知环境变化、传递信息并作出相应的行为反应。害羞草因此成为植物神经生物学研究中的明星模式生物。</p>`,
    category: 'kexue-yuanli',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20scientific%20visualization%20of%20electrical%20signals%20traveling%20through%20a%20Mimosa%20pudica%20stem%20cross-section%20glowing%20green%20and%20gold%20pathways%20representing%20action%20potentials%20dark%20background%20with%20subtle%20grid%20abstract%20data%20visualization%20style%20bioluminescent%20aesthetic%20cutting-edge%20plant%20neuroscience%20concept%20art%20clean%20and%20modern%20scientific%20illustration&width=640&height=360&seq=article-neural&orientation=landscape',
    date: '2026-08-03',
    readTime: '9 分钟',
  },
  {
    slug: 'xuexi-yu-jiyi-nengli',
    title: '害羞草的学习与记忆能力',
    excerpt: '反复刺激后害羞草不再闭合——这是"习惯化"现象，一种基本的学习形式。植物真的能学习和记忆吗？科学研究给出了令人惊讶的答案。',
    contentHtml: `<p>如果你持续不断地触碰一株害羞草的叶子，你会发现一个有趣的现象：一开始叶片会迅速闭合，但几分钟后，植株似乎变"懒"了，即使继续触碰也不再做出反应。这种看似简单的现象，实际上揭示了植物世界中最引人入胜的能力之一——习惯化学习。</p>
    <h4>习惯化实验</h4>
    <p>2014年，澳大利亚西澳大学的科学家Monica Gagliano博士进行了一个里程碑式的实验。她将害羞草从一定高度反复下落到柔软的缓冲垫上（这是一种标准化的机械刺激方法），观察叶片的闭合反应。最初几次下落，叶片立即闭合。但随着重复次数的增加，植株的反应越来越弱，最终完全不再闭合。</p>
    <p>更令人惊讶的是，当这些"习惯化"的植株被放置在不被干扰的环境中一段时间后再次测试，它们又恢复了闭合反应——这说明害羞草能够区分"有威胁"和"无威胁"的刺激，而不是简单地疲劳了。</p>
    <h4>长期记忆的证据</h4>
    <p>Gagliano的团队进一步发现，这种习惯化效应可以持续长达28天——对于一种没有大脑的生物来说，这堪称惊人。在弱光条件下培养的害羞草（这些植株更"珍惜"能量，因为光合作用受限）比强光条件下的植株表现出更强的习惯化效应，表明这是一种受能量预算调控的适应性行为。</p>
    <h4>机制假说</h4>
    <p>目前认为，害羞草的习惯化可能涉及钙离子信号的调控。反复的刺激可能导致钙离子通道的脱敏或细胞内钙库的耗竭，从而降低了后续刺激引发的反应幅度。也有假说认为表观遗传修饰可能参与长期记忆的存储。</p>
    <h4>哲学意义</h4>
    <p>这些研究动摇了传统的"学习需要神经系统"的观念。如果一株没有大脑的植物都能表现出学习和记忆能力，那么我们可能需要从根本上重新思考什么是"智能"和"意识"。害羞草用它的叶子向我们提出了一个深刻的哲学问题。</p>`,
    category: 'kexue-yuanli',
    imageUrl: 'https://readdy.ai/api/search-image?query=Conceptual%20artwork%20showing%20a%20Mimosa%20pudica%20plant%20with%20glowing%20neural%20network-like%20connections%20between%20its%20leaves%20abstract%20representation%20of%20plant%20memory%20and%20learning%20dark%20background%20with%20subtle%20bioluminescent%20effects%20scientific%20art%20style%20blend%20of%20botanical%20illustration%20and%20neuroscience%20imagery%20thought-provoking%20and%20beautiful%20composition%20exploring%20plant%20intelligence&width=640&height=360&seq=article-learning&orientation=landscape',
    date: '2026-08-05',
    readTime: '10 分钟',
  },
  {
    slug: 'huangye-bu-bihe-zenmeban',
    title: '黄叶、不闭合怎么办？',
    excerpt: '害羞草的叶子发黄了？碰了也不闭合了？别着急，这些常见问题的背后都有明确的原因和简单的解决方案。',
    contentHtml: `<p>养护害羞草的过程中，难免会遇到各种小问题。以下是最常见的几种异常表现及其解决方案。</p>
    <h4>问题一：叶片发黄</h4>
    <p>黄叶是害羞草最常出现的问题。可能的原因包括：浇水过多导致根系缺氧、浇水过少导致干旱胁迫、光照不足、缺铁或缺氮、自然老化等。</p>
    <p><strong>解决方法：</strong>首先检查土壤湿度。如果土壤过湿，暂停浇水，将植株移到通风处加快土壤干燥。如果土壤过干，逐渐增加浇水频率。将植株移到光照更充足的位置（避免暴晒）。对于缺铁导致的新叶黄化，可以施用螯合铁溶液。</p>
    <h4>问题二：叶片不闭合</h4>
    <p>如果害羞草碰到也不闭合了，通常有以下几个原因：光照严重不足、温度过低（低于18度时反应明显变慢）、植株过度疲劳（被反复触碰）、植株处于缺水状态。</p>
    <p><strong>解决方法：</strong>移到明亮散射光处养护，保持18-30度的适宜温度，让植株休息2-3天不要触碰，恢复正常浇水。</p>
    <h4>问题三：叶片边缘焦枯</h4>
    <p>通常是光照过强（暴晒）或施肥过量导致的灼伤。</p>
    <p><strong>解决方法：</strong>移到半阴处，如果刚施过肥可以用大量清水冲洗土壤降低肥料浓度。</p>
    <h4>问题四：植株徒长不开花</h4>
    <p>光照严重不足是最常见原因，氮肥过多也可能导致徒长。</p>
    <p><strong>解决方法：</strong>增加光照，减少氮肥比例，适当增施磷钾肥促进开花。</p>`,
    category: 'changjian-wenti',
    imageUrl: 'https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20of%20a%20healthy%20vibrant%20green%20Mimosa%20pudica%20on%20the%20left%20and%20a%20stressed%20plant%20with%20yellowing%20leaves%20on%20the%20right%20both%20in%20matching%20terracotta%20pots%20on%20a%20white%20surface%20educational%20plant%20health%20comparison%20bright%20natural%20lighting%20clean%20and%20minimal%20background%20botanical%20diagnostic%20photography%20clear%20visual%20difference%20between%20healthy%20and%20unhealthy%20specimens&width=640&height=360&seq=article-yellow&orientation=landscape',
    date: '2026-08-06',
    readTime: '7 分钟',
  },
  {
    slug: 'dongji-yanghu-zhuyi-shixiang',
    title: '冬季养护注意事项',
    excerpt: '害羞草怕冷不怕热。当气温降到15度以下时，就需要采取防寒措施。了解冬季养护要点，帮你的害羞草安全过冬。',
    contentHtml: `<p>害羞草是典型的热带植物，对低温非常敏感。在中国大部分地区，冬季养护是决定害羞草能否存活的关键。</p>
    <h4>温度管理</h4>
    <p>害羞草的最低耐受温度约为10度。当气温持续低于15度时，植株生长明显放缓；低于10度时，叶片开始出现寒害症状（变黑、脱落）；接近0度时，植株很可能被冻死。</p>
    <p>因此，在秋冬交替时（通常10月下旬到11月上旬），就应将室外的害羞草移入室内。冬季室内温度最好保持在15度以上，放置位置要远离冷风直吹的窗户和门口。</p>
    <h4>浇水调整</h4>
    <p>冬季害羞草进入半休眠状态，需水量大幅减少。浇水频率降低到每7-10天一次，每次浇水量也要减少。盆土保持微干状态，以手摸土面有轻微潮气即可。浇水时使用与室温相近的温水，避免冷水刺激根系。</p>
    <h4>光照补充</h4>
    <p>冬季日照时间短、强度弱，尽可能将害羞草放在朝南的窗边接受最大光照。如果室内光照严重不足，可以考虑使用植物补光灯，每天补充4-6小时的人工光照。</p>
    <h4>停止施肥</h4>
    <p>冬季完全停止施肥。此时植株代谢缓慢，施肥不仅无法被吸收，还可能在土壤中积累盐分伤害根系。等到来年春季新芽萌动时再恢复施肥。</p>
    <h4>春季过渡</h4>
    <p>来年春季气温回升到15度以上时，不要急于将害羞草搬出室外。给植株一个循序渐进的适应过程，先放在通风良好的室内窗边一周，再搬到室外半阴处一周，最后才能移到正常养护位置。</p>`,
    category: 'changjian-wenti',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20indoor%20winter%20scene%20with%20a%20Mimosa%20pudica%20plant%20on%20a%20wooden%20side%20table%20near%20a%20frost-covered%20window%20soft%20warm%20lamp%20light%20creating%20a%20cozy%20atmosphere%20knit%20blanket%20texture%20nearby%20snow%20visible%20through%20the%20window%20pane%20Scandinavian%20interior%20style%20hygge%20aesthetic%20warm%20cream%20and%20sage%20green%20color%20palette%20nurturing%20winter%20plant%20care%20ambiance&width=640&height=360&seq=article-winter&orientation=landscape',
    date: '2026-08-04',
    readTime: '6 分钟',
  },
  {
    slug: 'hanxiucao-yu-ertong-jiaoyu',
    title: '害羞草与儿童自然教育',
    excerpt: '害羞草是激发孩子对植物世界好奇心的完美教具。通过观察这株会"动"的植物，孩子们能获得宝贵的科学启蒙体验。',
    contentHtml: `<p>在孩子的眼中，一株会"害羞"的植物简直就是魔法。害羞草是进行自然教育和科学启蒙的绝佳载体，因为它将抽象的科学原理变成了孩子能亲眼看到、亲手感受到的奇妙体验。</p>
    <h4>激发好奇心</h4>
    <p>好奇心是科学思维的起点。当孩子第一次触碰害羞草、看到叶片迅速闭合时，那种惊奇的表情是任何课本都无法替代的。"为什么它会动？""它疼吗？""它在睡觉吗？"——这些问题引导着孩子走向观察、提问和探索的科学旅程。</p>
    <h4>培养观察力</h4>
    <p>鼓励孩子每天观察害羞草的变化：早晨叶片如何展开、触碰后多久闭合、多久恢复、光照强弱对反应速度的影响……可以准备一个简单的"观察日记"，让孩子用画图或简单文字记录每日观察结果。这种持续的观察训练对培养专注力和科学素养大有裨益。</p>
    <h4>建立生命观念</h4>
    <p>照顾一株害羞草，能帮助孩子建立对生命的尊重和责任感。按时浇水、观察生长、为它找到合适的阳光位置——这些看似简单的日常照料，都在潜移默化地培养孩子的爱心和责任感。</p>
    <p>许多幼儿园和小学都开始将害羞草引入自然角或科学区，让更多孩子有机会接触这株神奇植物。如果你家有小朋友，不妨一起种一盆害羞草，开启一段美好的亲子科学探索之旅。</p>`,
    category: 'changjian-wenti',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20young%20childs%20hand%20gently%20touching%20a%20Mimosa%20pudica%20plant%20in%20a%20bright%20sunny%20room%20look%20of%20wonder%20and%20curiosity%20on%20the%20childs%20face%20partially%20visible%20soft%20natural%20window%20light%20warm%20and%20educational%20atmosphere%20indoor%20setting%20with%20plants%20and%20books%20in%20background%20blur%20heartwarming%20lifestyle%20photography%20cream%20and%20green%20color%20palette%20innocent%20discovery%20moment&width=640&height=360&seq=article-kids&orientation=landscape',
    date: '2026-08-07',
    readTime: '6 分钟',
  },
];

export const reviews: Review[] = [
  {
    name: '林小美',
    role: '家庭园艺爱好者',
    content: '按照网站上的种植指南，我成功从种子养出了一盆害羞草！看到它第一次闭合叶子的那一刻，全家人都兴奋极了。网站内容非常详细，新手也能轻松上手。',
    rating: 5,
  },
  {
    name: '王老师',
    role: '小学科学教师',
    content: '把害羞草带到课堂上，孩子们都沸腾了。配合网站上的科学原理文章，我给学生们上了一堂生动的植物课。强烈推荐给所有教育工作者！',
    rating: 5,
  },
  {
    name: '陈阿姨',
    role: '退休园艺达人',
    content: '养了几十年花，害羞草是最有灵性的一种。这个网站的知识很全面，连扦插繁殖的技巧都讲得很清楚。我已经成功扦插了好几盆送给邻居了。',
    rating: 5,
  },
  {
    name: '张小明',
    role: '植物科普博主',
    content: '关于害羞草学习与记忆能力的那篇文章让我大开眼界。网站把复杂的科学原理讲得通俗易懂，既有深度又不失趣味，是我见过最专业的害羞草中文资料。',
    rating: 5,
  },
  {
    name: '李妈妈',
    role: '亲子教育倡导者',
    content: '带着五岁的女儿一起种害羞草，成了我们最棒的亲子活动。每天女儿都要去看看她的"害羞朋友"，还学会了写观察日记。感谢这个网站提供的灵感！',
    rating: 5,
  },
];

export const faqs: FAQ[] = [
  {
    question: '害羞草有毒吗？可以放在卧室吗？',
    answer: '害羞草全株无毒，对人体和宠物都是安全的。放在卧室完全没有问题。不过需要注意的是，害羞草在夜晚会自然闭合叶片（睡眠运动），这是正常的生理现象。',
  },
  {
    question: '害羞草可以活多久？是一年生还是多年生？',
    answer: '害羞草在适宜条件下是多年生植物，可以存活2-5年甚至更久。但在寒冷地区如果冬季不加保护，可能会被冻死。通过良好的越冬管理，你的害羞草可以陪伴你很多年。',
  },
  {
    question: '害羞草为什么有时候碰了也不闭合？',
    answer: '可能原因有：温度过低（低于18度时反应变慢）、光照不足、植株疲劳（短时间内被反复触碰）、缺水状态、或植株老化。给予适当光照、正常浇水和充分休息，通常可以恢复。',
  },
  {
    question: '害羞草的花期是什么时候？花是什么颜色的？',
    answer: '害羞草的花期通常在夏季（6-9月），花朵呈淡粉色或紫红色的球形头状花序，直径约1-2厘米，如同柔软的小绒球。花朵通常只开放一天，但整个花期会持续开出新花。',
  },
  {
    question: '害羞草的种子怎么收集？',
    answer: '花谢后会结出扁平的荚果，每个荚果内含2-4粒种子。当荚果由绿色变为棕褐色并开始自然开裂时，就可以采收。将种子放在阴凉通风处晾干后，密封保存在干燥阴凉处即可。',
  },
  {
    question: '害羞草可以水培吗？',
    answer: '害羞草不建议水培。它的根系对缺氧非常敏感，长期浸泡在水中容易导致根腐。使用排水良好的土壤盆栽是最适合害羞草的栽培方式。',
  },
];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((c) => c.slug === slug);
};

export const getRelatedArticles = (currentSlug: string, category: string, count: number = 3): Article[] => {
  return articles
    .filter((a) => a.category === category && a.slug !== currentSlug)
    .slice(0, count);
};